import api from "./api";

/**
 * Service Request API helpers.
 *
 * Currently only `createServiceRequest` lives here — added in Phase 14.1
 * so the new alert-detail "Create SR" flow has a clean home for its
 * outbound call. Other SR list/detail call sites still call `api` inline;
 * we'll consolidate over time.
 */
export const createServiceRequest = (data) =>
  api.post("/service-requests/", data).then((r) => r.data);
